<!--/**-->
<!--* 自动生成 vue列表代码【模块名：文件分片上传记录表】-->
<!--* 生成日期：2026/10/20 16:50:17-->
<!--* 生成路径: src/pages/file_upload/FileUploadList.vue-->
<!--* 生成人：管理员-->
<!--*/-->
<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <h3 class='page-title'>分片上传记录</h3>
        <div class='table-search'>
          <el-form :model='searchCondition' inline size='mini'>
            <el-form-item label='文件名称'>
              <el-input v-model='searchCondition.name' placeholder='文件名称' clearable></el-input>
            </el-form-item>
            <el-form-item label='文件Md5值'>
              <el-input v-model='searchCondition.md5' placeholder='文件Md5值' clearable></el-input>
            </el-form-item>
            <el-form-item label='创建时间'>
              <el-date-picker
                  v-model='searchCondition.date_range'
                  type='daterange'
                  align='right'
                  unlink-panels
                  range-separator='至'
                  start-placeholder='开始日期'
                  end-placeholder='结束日期'
                  value-format='yyyy-MM-dd'
                  :picker-options='pickerOptions'>
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' icon='el-icon-search' :disabled='loading' :loading='loading' @click='handleQuery'>搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--        操作栏-->
<!--        <div class='mb8 default-panel flex-left theme-border'>-->
<!--          <div>-->
<!--            <el-button type='primary' icon='el-icon-plus' v-if='hasAuthority("file_upload_create")' @click='handleAdd'>新增</el-button>-->
<!--          </div>-->
<!--          <div>-->
<!--            <el-button icon='el-icon-upload' v-if='hasAuthority("file_upload_import")' @click='openImport=true'>导入</el-button>-->
<!--          </div>-->
<!--          <div>-->
<!--            <export-btn ref='refLogisticSubscribeExport' :can-export='hasAuthority("file_upload_export")' @export='handleExport'></export-btn>-->
<!--          </div>-->
<!--        </div>-->
        <!-- 列表页签 -->
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
          <el-tab-pane label="列表" name="list">
            <!--    渲染表格-->
            <div class='default-table'>
              <MlPageTable :all-columns='defaultColumns'
                           :table-name='tableName'
                           :data-list='dataList'
                           :limit.sync='pageData.page_size'
                           :page.sync='pageData.current_page'
                           :total.sync='total'
                           highlight-current-row
                           :row-class-name='tableRowClassName'
                           @row-click='rowClickEvent'
                           @getList='getList' border>
                <el-table-column align='center' width='120' label='操作' fixed='right'>
                  <template slot-scope='{row}'>
<!--                    <el-button type='text' icon='el-icon-edit' v-if='hasAuthority("file_upload_edit")' @click='handleEdit(row)'>修改</el-button>-->
                    <el-button type='text' icon='el-icon-download' v-if='hasAuthority("file_upload_export")' :disabled='row.finish != 1' @click='handleDownload(row)'>下载</el-button>
                    <el-button type='text' icon='el-icon-delete' v-if='hasAuthority("file_upload_delete")' @click='handleDelete(row,$index)'>删除</el-button>
                  </template>
                </el-table-column>
              </MlPageTable>
            </div>
          </el-tab-pane>
          <el-tab-pane label="使用说明" name="use_note">
            <div class='theme-border default-padding mb8' style='min-height: 400px'>
              <ul>
                <li>使用流程：</li>
                <li>数据来源：平台数据-导入（各个平台的订单数据文件-excel）</li>
                <li>权限说明：</li>
              </ul>
            </div>
          </el-tab-pane>

        </el-tabs>


      </div>

      <!-- 添加或修改对话框 -->
      <el-dialog :title='title' :visible.sync='open' width='800px' append-to-body :close-on-click-modal='false'>
        <el-form ref='form' :model='form' :rules='rules' label-width='100px'>
          <el-form-item label='文件名称' prop='name'>
            <el-input v-model='form.name' placeholder='请输入文件名称' clearable/>
          </el-form-item>
          <el-form-item label='文件总大小' prop='total_size'>
            <el-input v-model='form.total_size' placeholder='请输入文件总大小' clearable/>
          </el-form-item>
          <el-form-item label='文件Md5值' prop='md5'>
            <el-input v-model='form.md5' placeholder='请输入文件Md5值' clearable/>
          </el-form-item>
          <el-form-item label='文件路径' prop='path'>
            <el-input v-model='form.path' placeholder='请输入文件路径' clearable/>
          </el-form-item>
          <el-form-item label='分片数量' prop='chunk_count'>
            <el-input v-model='form.chunk_count' placeholder='请输入分片数量' clearable/>
          </el-form-item>
          <el-form-item label='分片大小' prop='chunk_size'>
            <el-input v-model='form.chunk_size' placeholder='请输入分片大小' clearable/>
          </el-form-item>
          <el-form-item label='当前分片号' prop='chunk_num'>
            <el-input v-model='form.chunk_num' placeholder='请输入当前分片号' clearable/>
          </el-form-item>
          <el-form-item label='分片偏移值' prop='chunk_offset'>
            <el-input v-model='form.chunk_offset' placeholder='请输入分片偏移值' clearable/>
          </el-form-item>
          <el-form-item label='是否上传完成(主要是是否合成了分片)' prop='finish'>
            <el-input v-model='form.finish' placeholder='请输入是否上传完成(主要是是否合成了分片)' clearable/>
          </el-form-item>

        </el-form>
        <div slot='footer' class='dialog-footer'>
          <el-button type='primary' @click='submitForm' :disabled='loadingCommit' :loading='loadingCommit'>确 定
          </el-button>
          <el-button @click='cancel'>取 消</el-button>
        </div>
      </el-dialog>
      <!--      导入-->
      <ImportFileUpload :visible.sync='openImport' v-if='hasAuthority("file_upload_import")' @imported='handleQuery' />
    </PageHeaderLayout>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
import MlPageTable from '@/components/common/MlPageTable'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ExportBtn from '@/components/export/ExportBtn'
import ImportFileUpload from './ImportFileUpload'
import { deleteFileUpload, downloadFileUpload, exportFileUploads, getFileUploadInfo, getFileUploadList, saveFileUpload } from '@/api/file_upload'

export default {
  name: 'FileUploadList',
  components: { ImportFileUpload, ExportBtn, PageHeaderLayout, MlPageTable },
  data() {
    return {
      tableName: 'file_upload',
      activeName: 'list',
      loading: false,
      loadingCommit: false,
      dataList: [],
      total: 0,
      height: 800,
      searchCondition: { date_range: [],name: null, total_size: null, md5: null, path: null, chunk_count: null, chunk_size: null, chunk_num: null, chunk_offset: null, finish: null},
      pageData: { current_page: 1, page_size: 15 },
      orderBy: { id: 'asc' },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      defaultColumns:  [{ hide: false, prop: 'id', label: '序号', width: 80, sortable: true, fixed: false },
        { hide: false, prop: 'name', label: '文件名称', width: 220, sortable: false, fixed: false },
        { hide: false, prop: 'total_size', label: '文件总大小', width: 120, sortable: false, fixed: false },
        { hide: true, prop: 'md5', label: '文件Md5值', width: 120, sortable: false, fixed: false },
        { hide: true, prop: 'path', label: '文件路径', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'chunk_count', label: '分片数量', width: 120, sortable: false, fixed: false },
        { hide: true, prop: 'chunk_size', label: '分片大小', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'chunk_num', label: '当前分片号', width: 120, sortable: false, fixed: false },
        { hide: true, prop: 'chunk_offset', label: '分片偏移值', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'finish', label: '是否完成', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'created_at', label: '创建时间', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'updated_at', label: '修改时间', width: 120, sortable: true, fixed: false }],
      // 弹出层标题
      title: '添加/修改-文件分片上传记录表',
      // 是否显示弹出层
      open: false,
      // 表单校验
      rules:{name: [{ required: true, message: '文件名称不能为空', trigger: 'blur' }],
        total_size: [{ required: true, message: '文件总大小不能为空', trigger: 'blur' }],
        md5: [{ required: true, message: '文件Md5值不能为空', trigger: 'blur' }],
        path: [{ required: true, message: '文件路径不能为空', trigger: 'blur' }],
        chunk_count: [{ required: true, message: '分片数量不能为空', trigger: 'blur' }],
        chunk_size: [{ required: true, message: '分片大小不能为空', trigger: 'blur' }],
        chunk_num: [{ required: true, message: '当前分片号不能为空', trigger: 'blur' }],
        chunk_offset: [{ required: true, message: '分片偏移值不能为空', trigger: 'blur' }],
        finish: [{ required: true, message: '是否完成不能为空', trigger: 'blur' }]},
      // 表单参数
      form: {},
      //是否显示弹出层:导入框
      openImport: false,
      //筛选条件缓存key
      pageSearchKey:'page_search_key:file_upload'
    }
  },
  methods: {
    handleTabClick(){
      console.log(this.activeName)
    },
    // eslint-disable-next-line no-unused-vars
    rowClickEvent(row, column, event) {
      // this.$notify.info(`数据ID：${row.id}`)
    },
    // eslint-disable-next-line no-unused-vars
    tableRowClassName({ row, rowIndex }) {
      return 'default-table-row'
    },
    handleSearchCondition() {
      let condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field] != null) {
          if (Object.prototype.toString.call(this.searchCondition[field]) === '[object Array]') {
            if (this.searchCondition[field].length > 0) {
              condition[field] = this.searchCondition[field]
            }
          } else {
            // 字符串长度大于0
            if (this.searchCondition[field])
              condition[field] = this.searchCondition[field]
          }
        }
      })
      // 分页 +排序
      Object.assign(condition, this.pageData, { orderBy: this.orderBy })

      return condition
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
      //缓存筛选条件，刷新后可以继续使用
      sessionStorage.setItem(this.pageSearchKey, JSON.stringify(this.searchCondition))
    },
    async getList() {
      this.dataList = []
      this.loading = true
      let params = this.handleSearchCondition()
      let { list, pages } = await getFileUploadList(params)
      // this.dataList = [...this.dataList, ...list]
      this.dataList = list
      this.pageData.current_page = pages.current_page || 1
      this.pageData.page_size = pages.page_size || 100
      this.total = pages.total
      this.loading = false
    },
    /** 删除按钮 */
    handleDelete(row, index) {
      if (row.id) {
        //真实删除
        this.$confirm('此操作将删除该行数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delRow(row.id)
          this.dataList.splice(index, 1)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        this.tableData.splice(index, 1)
      }
    },
    async delRow(id) {
      await deleteFileUpload(id)
    },
    /** 下载已上传完成的文件 */
    async handleDownload(row) {
      if (row.finish != 1) {
        this.$message.warning('文件尚未上传完成，无法下载')
        return
      }
      try {
        const response = await downloadFileUpload(row.id)
        if (!response || !(response.data instanceof Blob)) {
          this.$message.warning((response && response.msg) || '下载异常，请联系管理员')
          return
        }
        const contentType = response.headers['content-type']
        const blob = new Blob([response.data], { type: contentType })
        const fileName = row.name || (row.path || '').split(/[\\/]/).pop() || '下载文件'
        FileSaver.saveAs(blob, fileName)
      } catch (e) {
        this.$message.warning('下载异常，请联系管理员')
      }
    },
    /** 修改按钮 */
    handleAdd() {
      this.open = true
      this.title = '添加-文件分片上传记录表'
      this.form = {}
    },
    /** 修改按钮 */
    async handleEdit(row) {
      this.open = true
      this.title = '修改-文件分片上传记录表'
      let { info } = await getFileUploadInfo(row.id)
      this.form = { ...info }
    },

    /** 提交按钮 */
    async submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loadingCommit = true
          saveFileUpload(this.form).then(id => {
            if (id) {
              if (!this.form.id)
                this.msgSuccess('新增成功')
              else
                this.msgSuccess('修改成功')

              this.form.id = id
              this.open = false
              this.getList()
            } else {
              this.msgError('操作失败')
            }
            setTimeout(() => {
              this.loadingCommit = false
            }, 500)
          })

        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.form = {}
    },
    //导出表格
    async handleExport() {
      try {
        let searchCondition = this.handleSearchCondition()
        let response = await exportFileUploads(searchCondition)
        let name = `文件分片上传记录表`

        this.$refs.refLogisticSubscribeExport.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
        this.$refs.refLogisticSubscribeExport.hideLoading()
      }
    },
  },
  created() {
    if (sessionStorage.getItem(this.pageSearchKey)) {
      this.searchCondition = JSON.parse(sessionStorage.getItem(this.pageSearchKey))
    }
    this.handleQuery()
  }
}
</script>

<style scoped>
.main-page-content > .page-title {
  margin: 0;
  padding: 14px 10px 12px;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
}
</style>
